/**
 * Creates a lookup object from an array of items, keyed by a id and uuid
 *
 * @param dataArray - Array of items to group
 * @param idProp - Name of the property to use as the key (default: 'id')
 * @param uuidProp - Name of the property to prefer as the key (default: 'uuid')
 * @returns Record object with items keyed by their uuid or id
 */
export function fastGroupById<T>(
  dataArray: T[],
  idProp: string = 'id',
  uuidProp: string = 'uuid'
): Record<string, T> {
  const o = {};
  dataArray.forEach((item) => {
    o[item[idProp]] = item;

    // Temp solution until we cutover complete to UUIDs for accounts
    if (item[uuidProp] != null) {
      o[item[uuidProp]] = item;
    }
  });
  return o;
}
